"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentLocalizedReferenceTypeGroupSchema = void 0;
exports.ContentLocalizedReferenceTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContentLocalizedReferenceTypeGroup",
    "description": "ContentLocalizedReferenceTypeGroup represents one of the following types: AppleImmersiveVideoLocalizedReference, AudioClipLocalizedReference, AudioEpisodeLocalizedReference, AudioSeasonLocalizedReference, AudioSeriesLocalizedReference, AuthorProfileLocalizedReference, ContentCollectionLocalizedReference, EditorialListLocalizedReference, EnergyDrinkLocalizedReference, EpisodeVideoLocalizedReference, EventDetailLocalizedReference, EventProfileLocalizedReference, EventSeasonLocalizedReference, EventSeriesLocalizedReference, ExternalPersonLocalizedReference, ExternalTeamLocalizedReference, ExternalContentLocalizedReference, FilmLocalizedReference, ImageGalleryLocalizedReference, ImageLocalizedReference, Immersive3DModelLocalizedReference, JudgeLocalizedReference, LiveVideoLocalizedReference, LocationLocalizedReference, MiscLocalizedReference, OccasionCampaignLocalizedReference, OccasionLocalizedReference, OnsitePromotionLocalizedReference, PartnerProfileLocalizedReference, PersonProfileLocalizedReference, PhotographerLocalizedReference, PlaylistLocalizedReference, PreviewClipLocalizedReference, ProjectProfileLocalizedReference, RallyDriverLocalizedReference, RallyTeamLocalizedReference, RecapVideoLocalizedReference, ResultsAndStandingsLocalizedReference, SeasonLocalizedReference, ShowLocalizedReference, StoryLocalizedReference, TagLocalizedReference, TeamProfileLocalizedReference, TrailerVideoLocalizedReference, TvCommercialLocalizedReference, TvPartnerChannelLocalizedReference, Video3DLocalizedReference, VideoChannelLocalizedReference, VideoLocalizedReference, Video360LocalizedReference",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/apple-immersive-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/audio-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/audio-episodes.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/audio-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/audio-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/author-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/collections.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/editorial-lists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/energy-drinks.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/episode-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/event-details.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/event-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/event-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/event-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/external-persons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/external-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/externals.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/films.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/image-galleries.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/images.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/immersive-3d-models.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/judges.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/live-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/locations.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/misc.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/occasion-campaigns.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/occasions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/onsite-promotions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/partner-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/person-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/photographers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/playlists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/preview-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/project-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/rally-drivers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/rally-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/recap-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/results-standings.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/shows.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/stories.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/tags.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/team-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/trailer-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/tv-commercials.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/tv-partner-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/video-3d.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/video-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/localized/content/videos-360.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,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